import { Icon } from '@iconify/react';
import { useRef } from 'react';
import syncOutline from '@iconify/icons-eva/sync-outline';

// material
import { ListItemText, MenuItem } from '@mui/material';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { createWithQuery } from '../../fetch';
import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

FlightReviewRecalculet.propTypes = {
  reportTrip: PropTypes.object.isRequired,
  state: PropTypes.object,
  setState: PropTypes.func,
  setIsOpenSpeedDial: PropTypes.func.isRequired
};

export default function FlightReviewRecalculet({
  reportTrip,
  state,
  setState,
  setIsOpenSpeedDial
}) {
  const t = useTranslation();
  const ref = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleReformerVol = async (endPoint) => {
    setState({ ...state, refresh: true });
    const response = await createWithQuery(
      `altitude/sol/correction/${endPoint}?deviceId=${reportTrip.deviceId}&from=${moment(
        reportTrip.startTime
      ).toISOString()}&to=${moment(reportTrip.endTime).toISOString()}`
    );
    if (response.ok) {
      setState({ ...state, refreshAnalyse: !state.refreshAnalyse });
      enqueueSnackbar(t('FR_ElevationRecalculated'), { variant: 'success' });
    }
    setState({ ...state, refresh: false });
    setIsOpenSpeedDial(false);
  };
  return (
    <MenuItem sx={{ color: 'text.secondary' }} onClick={() => handleReformerVol('ign')} ref={ref}>
      <Icon icon={syncOutline} width={23} height={23} />
      <ListItemText
        primary={t('FR_Tooltip_RecalculateHeight')}
        primaryTypographyProps={{ variant: 'body2' }}
      />
    </MenuItem>
  );
}
